"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseQuota_1 = __importDefault(require("./BaseQuota"));
class SavedReportsQuota extends BaseQuota_1.default {
    reclaim(quotas, job) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!quotas.saved_reports) {
                return job;
            }
            const stat = yield this.statsCollection.getAllTimeStats(job.ownerId, 'saved_reports');
            let usage = stat.value - job.quantity;
            if (usage < 0) {
                usage = 0;
            }
            stat.value = usage;
            yield this.statsCollection.setDoc(stat);
            return job;
        });
    }
    calc(quotas, job) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!quotas.saved_reports) {
                job.status = 'rejected';
                job.statusReason = "No quota limit";
                return job;
            }
            const stat = yield this.statsCollection.getAllTimeStats(job.ownerId, 'saved_reports');
            if (stat.value + job.quantity > quotas.saved_reports) {
                job.status = 'rejected';
                job.statusReason = "Quota limit reached";
                return job;
            }
            stat.value += job.quantity;
            yield this.statsCollection.setDoc(stat);
            job.status = 'allowed';
            return job;
        });
    }
}
exports.default = SavedReportsQuota;
